export default "__VITE_PUBLIC_ASSET__9afb0197__"